import useBoolState from 'bundles/admin/hooks/useBoolState'
import useOrganisations from 'bundles/admin/hooks/useOrganisations'
import {pluralise} from 'bundles/admin/lib/format'
import React, {Fragment, useEffect, useRef} from 'react'
import {Link, useParams, useLocation} from 'react-router-dom'
import GlobalAccountField from '../shared/GlobalAccountField'

export default ({onSelect}) => {
  const {organisationID} = useParams()
  const location = useLocation()
  const {organisations} = useOrganisations()
  const [dropdownIsOpen, setDropdownIsOpen, toggleDropdownIsOpen] = useBoolState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setDropdownIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const currentOrganisation = organisations.find(org => org.id === organisationID)
  const otherOrganisations = organisations.filter(org => org.id !== organisationID)

  const handleSelection = e => {
    setDropdownIsOpen(false)
    onSelect()
  }

  const rewriteOrganisationPath = org => {
    // Split the pathname into segments
    const segments = location.pathname.split('/')
    // Keep only the first 4 segments (indices 0, 1, 2, 3)
    // e.g. /orgs/1/accounts (segment 0 is an empty String)
    const truncatedSegments = segments.slice(0, 4)
    // Substitute the organisationId
    truncatedSegments[2] = org.id
    return truncatedSegments.join('/')
  }

  return (
    <Fragment>
      <li>
        <GlobalAccountField />
      </li>
      {currentOrganisation ? (
        <li className='dropdown-menu-baysic' ref={ref}>
          <a
            style={
              organisations.length && currentOrganisation.internalColor
                ? {borderTop: `4px solid #${currentOrganisation.internalColor}`}
                : {}
            }
            className={`dropdown-trigger-baysic ${dropdownIsOpen ? 'open' : ''} active with-sup`}
            onClick={toggleDropdownIsOpen}>
            <sup>My {pluralise('Organisation', organisations.length)}</sup>
            <br />
            {currentOrganisation.internalName}
            &nbsp;&nbsp;
            <i className='fa fa-caret-down' aria-hidden='true'></i>
          </a>

          <ul className='dropdown-items-baysic'>
            {organisations.length ? (
              <Fragment>
                {otherOrganisations.map(org => (
                  <li key={org.id}>
                    <a
                      style={org.internalColor ? {borderLeft: `8px solid #${org.internalColor}`} : {}}
                      href={rewriteOrganisationPath(org)}>
                      {org.internalName}
                    </a>
                  </li>
                ))}
                <li>
                  <span className='break'></span>
                </li>
              </Fragment>
            ) : null}
            <li>
              <Link to={`/orgs/${organisationID}/edit`} aria-label='Edit organisation' onClick={handleSelection}>
                Edit
              </Link>
            </li>
          </ul>
        </li>
      ) : null}

      <li>
        <a href='/admins/edit' aria-label='Edit profile'>
          Profile
        </a>
      </li>
      <li>
        <a href='/admins/sign_out' aria-label='Log out'>
          Log Out
        </a>
      </li>
    </Fragment>
  )
}
